export default __webpack_public_path__ + "static/media/icon.14207bb4.png";